import React, { useState } from 'react';
import {
  Grid,
  Paper,
  Typography,
  Box,
  Tabs,
  Tab,
  Button,
  Card,
  CardContent,
  LinearProgress,
  Chip,
  IconButton
} from '@mui/material';
import {
  Assessment,
  CalendarToday,
  Description,
  Notifications,
  Search,
  Settings
} from '@mui/icons-material';
import { StateFilingAutomationService } from '../../sponsfi/services/StateFilingAutomationService';
import { ComplianceCalendar } from './ComplianceCalendar/ComplianceCalendar';
import { FilingQueue } from './FilingQueue/FilingQueue';
import { ComplianceAnalytics } from './ComplianceAnalytics/ComplianceAnalytics';
import { DocumentManager } from './DocumentManager/DocumentManager';
import { ComplianceSettings } from './Settings/ComplianceSettings';
import { useAuth } from '../../hooks/useAuth';
import { Link, Outlet } from 'react-router-dom';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export const SmartComplyDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { user } = useAuth();

  // Quick stats for the dashboard
  const complianceStats = {
    totalFilings: 156,
    pendingFilings: 23,
    upcomingDeadlines: 12,
    complianceScore: 94
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  if (!user?.fiscalSponsorId) {
    return (
      <Box p={3}>
        <Typography color="error">
          Error: No fiscal sponsor ID found. Please contact support.
        </Typography>
      </Box>
    );
  }

  return (
    <div className="smart-comply-container">
      <nav className="smart-comply-nav">
        <ul>
          <li>
            <Link to="filings">
              <i className="fas fa-file-alt"></i>
              Filings
            </Link>
          </li>
          <li>
            <Link to="calendar">
              <i className="fas fa-calendar"></i>
              Calendar
            </Link>
          </li>
          <li>
            <Link to="documents">
              <i className="fas fa-folder"></i>
              Documents
            </Link>
          </li>
          <li>
            <Link to="analytics">
              <i className="fas fa-chart-bar"></i>
              Analytics
            </Link>
          </li>
          <li>
            <Link to="notary">
              <i className="fas fa-stamp"></i>
              Notary Service
            </Link>
          </li>
          <li>
            <Link to="settings">
              <i className="fas fa-cog"></i>
              Settings
            </Link>
          </li>
        </ul>
      </nav>
      <div className="smart-comply-content">
        <Outlet />
      </div>
    </div>
  );
}; 